export default {
    data() {
        return {
            activeName: '汽运',
            carCharts: null,
            jiaohuodi: '',
            timeStart: '',
            timeEnd: '',
            pinming: '',
            cartsOther: null,
            orderNo: ''
        };
    },
    methods: {
        getCarCharts() {
            let that = this;
            if (that.carCharts === null) {
                that.carCharts = that.$echarts.init(document.getElementById("car-echarts"));
            }
            that.carCharts.setOption({
                xAxis: {
                    type: 'category',
                    data: ['待发货', '待卸货', '待确认', '已确认', '已取消']
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value} '  // 在Y轴上显示自定义文字
                    },
                    name: '单位（车）'
                },
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        data: [5, 3, 3, 4, 1],
                        type: 'bar',
                        showBackground: true,
                        backgroundStyle: {
                            color: 'rgba(180, 180, 180, 0.2)'
                        },
                        itemStyle: {
                            color: 'rgb(85,142,236)'  // 设置柱子的颜色为蓝色
                        },
                        label: {
                            show: true,  // 显示数字
                            position: 'top',  // 设置数字显示在柱子上方
                            color: 'black',  // 设置数字颜色
                            fontSize: 14  // 设置数字的字体大小
                        }
                    }
                ]
            });
        },
        getChartsOhter() {
            let that = this;
            if (that.cartsOther === null) {
                that.cartsOther = that.$echarts.init(document.getElementById("cartsOther"));
            }
            that.cartsOther.setOption({
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: '50%',
                        data: [
                            { value: 1048, name: 'Search Engine' },
                            { value: 735, name: 'Direct' },
                            { value: 580, name: 'Email' },
                            { value: 484, name: 'Union Ads' },
                            { value: 300, name: 'Video Ads' }
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            });
        }
    },
    created() {
        console.log('123')
        this.$nextTick(() => {
            this.getCarCharts();
        });
        this.$nextTick(() => {
            this.getChartsOhter();
        });
    }
}